import React from 'react';

import type { PmConverters } from './collect';

export const ConvertersContext = React.createContext<PmConverters | undefined>(undefined);

export const useConverters = (): PmConverters => {
  const ctx = React.useContext(ConvertersContext);
  if (!ctx) {
    throw new Error('ConvertersContext not provided.');
  }
  return ctx;
};
